import React, { useEffect } from 'react';
import './Popover.css';

const Popover = ({ title, onClose, children }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="popover-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="popover-title">
      <div className="popover-window" onClick={(e) => e.stopPropagation()}>
        <div className="popover-header">
          <h2 id="popover-title" className="popover-title">{title}</h2>
          <button
            type="button"
            className="popover-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="popover-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Popover;
